import React from 'react'

function Thanks() {
  return (
    <>
        <div className='h-screen text-center mt-48'>
        
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-transparent  bg-clip-text bg-gradient-to-r from-neon-cyan to-neon-purple">
              Thanks For Visiting 
            </span>
          </h2>

        </div>
    </>
  )
}

export default Thanks